import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import CustomButton from "../Button";
import useAuth from "../../Hooks/useAuth";
import { googleIconImg } from "../../Constants/Images";
import { Link } from "react-router";
import SignupForm from "../../Pages/Auth/SignupForm";
import ForgotPassword from "../../Pages/Auth/ForgotPasswordForm";
import { AuthActiveFormType } from "../../Constants/Interfaces";
import GoogleLoginBtn from "../GoogleLoginBtn";

interface LoginModalType {
  show: boolean;
  onClose: Function;
  onSuccess: Function;
}

const LoginModal: React.FC<LoginModalType> = ({ show, onClose, onSuccess }) => {
  const { data, errors, loading, onChange, submitLogin } = useAuth();

  const [activeForm, setActiveForm] = useState<AuthActiveFormType>("Login");

  return (
    <Modal show={show} onHide={() => onClose()}>
      <Modal.Header closeButton>{activeForm}</Modal.Header>
      <Modal.Body>
        {activeForm == "Login" && (
          <div className="auth-form-wrapper">
            <div className="auth-headings">
              <h3>Welcome Back</h3>
              <p>Please log in here</p>
            </div>

            <div className="auth-form">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={data.email}
                  onChange={(e) => onChange("email", e.target.value)}
                />
                {errors.email && errors.email !== "" && (
                  <span className="error">{errors.email}</span>
                )}
              </div>

              <div className="form-group">
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  placeholder="Enter password"
                  value={data.password}
                  onChange={(e) => onChange("password", e.target.value)}
                />
                {errors.password && errors.password !== "" && (
                  <span className="error">{errors.password}</span>
                )}
              </div>

              <CustomButton
                isLoading={loading}
                title="Login"
                onClick={() => submitLogin(onSuccess ? onSuccess : onClose)}
              />

              <span
                className="forgot-link as-link"
                onClick={() => setActiveForm("Forgot Password")}
              >
                Forgot Password
              </span>
            </div>

            <div className="login-with-or-text">
              <span>or</span>
            </div>

            <div className="social-login-btn-wrapper">
              <GoogleLoginBtn onSuccess={onSuccess ? onSuccess : onClose} />
            </div>

            <div className="have-an-account-links">
              <p>
                Don’t have an account?{" "}
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveForm("SignUp");
                  }}
                >
                  Sign Up
                </Link>
              </p>
              <p>
                Question? Need help? <Link to="#">Support Can Help</Link>
              </p>
            </div>
          </div>
        )}

        {activeForm == "SignUp" && (
          <SignupForm
            type="modal"
            onSuccess={() => onClose()}
            changeForm={(form: AuthActiveFormType) => setActiveForm(form)}
          />
        )}

        {activeForm == "Forgot Password" && (
          <ForgotPassword
            changeForm={(form: AuthActiveFormType) => setActiveForm(form)}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
